import { useNavigate } from 'react-router-dom'
import { Monitor } from 'lucide-react'
import MobileLayout from './MobileLayout'

export default function MobileUnavailable() {
  const navigate = useNavigate()
  return (
    <MobileLayout title="UP-CRM">
      <div className="flex-1 flex flex-col items-center justify-center text-center px-8 py-16">
        <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <Monitor className="w-8 h-8 text-gray-400" />
        </div>
        <h2 className="text-lg font-bold text-gray-900">Disponible sur ordinateur</h2>
        <p className="text-sm text-gray-500 mt-2">
          Le tableau de bord, l'export et les champs personnalisés ne sont accessibles que depuis un ordinateur.
        </p>
        <button
          onClick={() => navigate('/contacts')}
          className="mt-5 px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700"
        >
          Retour aux contacts
        </button>
      </div>
    </MobileLayout>
  )
}
